// Formes du chemin code-barres (lecture locale + Open Food Facts), entièrement côté navigateur
// (CLAUDE.md § « Contrat d'API » : pas d'appel à api/ sur ce chemin). `MacrosPer100g` recopie
// volontairement la forme de `api/src/types.ts` (source de vérité documentée) : les deux workspaces
// npm (`web`, `api`) ne partagent pas de code, et ce dépôt n'a pas d'outillage de monorepo pour
// générer un type partagé.

/** Composition nutritionnelle pour 100 g d'un aliment — même forme que `api/src/types.ts`. */
export interface MacrosPer100g {
  kcal: number;
  glucides_g: number;
  proteines_g: number;
  lipides_g: number;
  fibres_g: number;
  sucres_g: number;
  sel_g: number;
}

/** Détection brute d'un lecteur de code-barres (natif ou ZXing), avant sélection du meilleur résultat. */
export interface BarcodeDetection {
  rawValue: string;
  format: string;
}

/** Produit Open Food Facts normalisé, composition utilisable (jamais de `nutriments` incomplet ici). */
export interface OffProduct {
  ean: string;
  productName: string | null;
  nutriments: MacrosPer100g;
  /** Texte brut OFF (ex. « 30 g », « 1 portion (25g) »), tel quel pour affichage. */
  servingSize: string | null;
  /** `servingSize` réduit en grammes quand c'est possible à parser, sinon `null`. */
  servingGrams: number | null;
  nutriscoreGrade: string | null;
  imageUrl: string | null;
}

/** URL de contribution à Open Food Facts pour un EAN donné (item 6 de l'objectif — un lien, jamais d'écriture depuis l'app). */
export function offContributeUrl(ean: string): string {
  return `https://world.openfoodfacts.org/cgi/product.pl?type=add&code=${encodeURIComponent(ean)}`;
}

/**
 * Résultat d'une recherche Open Food Facts par EAN :
 * - `found` : composition exacte utilisable, macros et poids exploitables.
 * - `incomplete` : la fiche existe mais `nutriments` n'a pas de quoi calculer une composition fiable
 *   (champs manquants — fréquent sur OFF) → dégrade vers le chemin modèle, contribution utile.
 * - `not-found` : EAN inconnu d'OFF → dégrade vers le chemin modèle, proposer de créer la fiche.
 */
export type OffLookupResult =
  | { status: 'found'; product: OffProduct }
  | { status: 'incomplete'; ean: string; productName: string | null; contributeUrl: string }
  | { status: 'not-found'; ean: string; contributeUrl: string };
